import _defineProperty from "/app/vetiver/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import clsx from 'clsx';
import React, { forwardRef } from 'react';
import { alpha, makeStyles } from '@material-ui/core/styles';
import { capitalize } from '@material-ui/core/utils';
import { IconButton } from '@material-ui/core';
import { ButtonAnimate } from '../../components/Animate'; // ----------------------------------------------------------------------

var useStyles = makeStyles(function (theme) {
  var createStyle = function createStyle(color) {
    return {
      color: theme.palette[color].main,
      '&:hover': {
        backgroundColor: alpha(theme.palette[color].main, theme.palette.action.hoverOpacity)
      }
    };
  };

  return {
    colorInfo: createStyle('info'),
    colorSuccess: createStyle('success'),
    colorWarning: createStyle('warning'),
    colorError: createStyle('error'),
    colorWhite: {
      color: theme.palette.common.white,
      '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, theme.palette.action.hoverOpacity)
      }
    }
  };
});
export var MIconButton = forwardRef(function (_a, ref) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'default' : _a$color,
      children = _a.children,
      className = _a.className,
      other = __rest(_a, ["color", "children", "className"]);

  var classes = useStyles();

  if (color === 'default' || color === 'inherit' || color === 'primary' || color === 'secondary') {
    return React.createElement(ButtonAnimate, null, React.createElement(IconButton, Object.assign({
      ref: ref,
      color: color,
      className: className
    }, other), children));
  }

  return React.createElement(ButtonAnimate, null, React.createElement(IconButton, Object.assign({
    ref: ref,
    className: clsx(_defineProperty({}, classes["color".concat(capitalize(color))], true), className)
  }, other), children));
});